module.exports = __webpack_public_path__ + "img/main-banner.b47c39d6.png";